import { React, models, kea, history, resources, selectores, componentToRx, Route, withRouter } from "app/main/std";
import { observeResource } from "kea-resource";
import { RemplazoUsuarioEdit } from "./remplazarusuariomodal";

type Entity = models.Usuario;
import { columnas } from "./columns";
const resource = resources.Usuario;
const observable = observeResource(resources.Usuario.query, {});
export class UsuarioList extends React.PureComponent {
    modalManager = kea.createModalManager();

    onBorrar = async (x: Entity) => {
        if (await kea.yesno("¿Borrar Usuario?", x.Nombre)) {
            await resource.delete(x.IdRegistro);
        }
    }

    onRemplazar = async (x: Entity) => {
        if (await kea.yesno("¿Remplazar Usuario?", x.Nombre)) {
            const result = await this.modalManager.showModal(RemplazoUsuarioEdit, undefined, { IdUsuario: x.IdRegistro } as models.RemplazoUsuario);
            if (result.result) {
                const idRegistro = await resource.RemplazarUsuario(result.value as models.RemplazoUsuario);
                history.go(`./${idRegistro}`);
            }
        }
    }

    onEdit = (x: Entity) => history.go("/catalogos/Usuario/" + x.IdRegistro);
    onAgregar = () => history.go("/catalogos/Usuario/new");
    onRegresar = () => history.go("/catalogos");

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Title titulo="Usuarios" onRegresar={this.onRegresar}>
                    <kea.AgregarButton onClick={this.onAgregar} />
                </kea.Title>

                <kea.Grid2 columnas={cols} cookieKey={"UsuariosListCookieKey"} items={observable} />
                {this.modalManager.component}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuarios/list/list.tsx